import React, { useState } from 'react';
import { MapaIndicadores } from '../../../../assets/MapaIndicadores';
import homeIndicatorsBgUrl from '../../../../assets/images/home-indicators-bg.png';
import IndicatorsBand from '../../../IndicatorsBand/IndicatorsBand';
import ModalMessage from '../../Modal/ModalMessage';
import ModalConfirm from '../../Modal/ModalConfirm';
import './SectionIndicadores.css';

export default function SectionIndicadores({
  isEditing,
  tituloIndicadores,
  setTituloIndicadores,
  imagemIndicadores,
  setImagemIndicadores,
  indicadores,
  setIndicadores
}) {
  const [modalMessage, setModalMessage] = useState('');
  const [isModalMessageOpen, setIsModalMessageOpen] = useState(false);
  const [isModalConfirmOpen, setIsModalConfirmOpen] = useState(false);
  const [indicadorParaRemover, setIndicadorParaRemover] = useState(null);

  // Processa o arquivo selecionado e atualiza a referência local para o background
  const handleBgUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!['image/jpeg', 'image/png'].includes(file.type)) {
      setModalMessage('Formato inválido. A imagem deve ser JPG ou PNG.');
      setIsModalMessageOpen(true);
      return;
    }

    if (file.size > 15 * 1024 * 1024) {
      setModalMessage('A imagem é muito grande. O tamanho máximo permitido é 15MB.');
      setIsModalMessageOpen(true);
      return;
    }

    setImagemIndicadores({
      url: URL.createObjectURL(file),
      file: file
    });
  };

  // Atualiza um campo específico no array de indicadores
  const handleIndicadorChange = (index, campo, valor) => {
    const novos = [...indicadores];
    novos[index] = { ...novos[index], [campo]: valor };
    setIndicadores(novos);
  };

  // Insere um indicador padrão vazio na lista
  const handleAddIndicador = () => {
    setIndicadores([
      ...indicadores,
      { id: Date.now(), value: '', description: '' }
    ]);
  };

  // Remove um indicador ativo com validação de registro mínimo
  const handleRemoveIndicador = (indexToRemove) => {
    if (indicadores.length <= 1) {
      setModalMessage('Deve manter pelo menos um indicador cadastrado.');
      setIsModalMessageOpen(true);
      return;
    }

    setIndicadorParaRemover(indexToRemove);
    setIsModalConfirmOpen(true);
  };

  const handleConfirmRemoveIndicador = () => {
    if (indicadorParaRemover !== null) {
      setIndicadores(indicadores.filter((_, idx) => idx !== indicadorParaRemover));
    }
    setIsModalConfirmOpen(false);
    setIndicadorParaRemover(null);
  };

  const currentBgUrl = typeof imagemIndicadores === 'object' && imagemIndicadores?.url
    ? imagemIndicadores.url
    : (imagemIndicadores || homeIndicatorsBgUrl);

  const normalizedIndicators = indicadores.map((item) => ({
    ...item,
    label: item.label || item.description,
    description: item.label ? item.description : ''
  }));

  return (
    <section className="section-indicadores-admin">
      <div className="section-indicadores-admin__wrapper">
        <IndicatorsBand
          title={tituloIndicadores || 'Nossos indicadores'}
          imageUrl={currentBgUrl}
          indicators={normalizedIndicators}
          decoration={<MapaIndicadores />}
          showOverlay={false}
        />

        {isEditing && (
          <div className="indicadores-admin__edit-layer">
            
            <div className="indicadores-admin__header-edit">
              <div className="input-group-admin">
                <label>Título da Seção</label>
                <input
                  type="text"
                  value={tituloIndicadores}
                  onChange={(e) => setTituloIndicadores(e.target.value)}
                  placeholder="Ex: Nossos indicadores"
                />
              </div>

              <label className="btn-admin-upload-bg">
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  onChange={handleBgUpload}
                  hidden
                />
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5-7l-3 3.72L9 13l-3 4h14l-4-5z" />
                </svg>
                <span>Substituir Imagem do Mapa / Fundo</span>
              </label>
            </div>

            <div className="indicadores-admin__cards-edit">
              {indicadores.map((ind, index) => (
                <div key={ind.id || ind._id || index} className="indicador-admin-item-edit">
                  <div className="indicador-admin-item-edit__fields">
                    <input
                      type="text"
                      className="input-ind-val"
                      value={ind.value}
                      onChange={(e) => handleIndicadorChange(index, 'value', e.target.value)}
                      placeholder="Ex: +300"
                    />
                    <input
                      type="text"
                      className="input-ind-desc"
                      value={ind.description || ind.label || ''}
                      onChange={(e) => handleIndicadorChange(index, 'description', e.target.value)}
                      placeholder="Ex: atendidos"
                    />
                  </div>

                  <button
                    type="button"
                    className="btn-remover-indicador"
                    onClick={() => handleRemoveIndicador(index)}
                    title="Remover este indicador"
                  >
                    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </div>
              ))}
            </div>

            <button
              type="button"
              className="btn-add-indicador"
              onClick={handleAddIndicador}
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
              </svg>
              Adicionar Indicador
            </button>

          </div>
        )}
      </div>

      <ModalMessage
        isOpen={isModalMessageOpen}
        onClose={() => setIsModalMessageOpen(false)}
        message={modalMessage}
      />

      <ModalConfirm
        isOpen={isModalConfirmOpen}
        onClose={() => setIsModalConfirmOpen(false)}
        onConfirm={handleConfirmRemoveIndicador}
        message="Confirmar a exclusão deste indicador?"
      />
    </section>
  );
}
